import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepsModule } from 'primeng/steps';
import { Stepper, StepperModule } from 'primeng/stepper';
import { ButtonModule } from 'primeng/button';
import { ExpenseAddDetailsComponent } from '../1-ExpenseDetailsStep/expense-add-details.component';
import { ExpenseAddLineItemsComponent } from '../2-LineItemsAndAttachmentStep/expense-add-lineitems.component';
import { ExpenseAddApprovalsComponent } from '../3-ApprovalsStep/expense-add-approvals.component';
import { ExpenseAddComplianceComponent } from '../4-ComplianceStep/expense-add-compliance.component';
import { ExpenseAddItemizationComponent } from '../5-ItemizationStep/expense-add-itemization.component';
import { GenericButtonComponent } from "../../../../global/component/generic/generic-button/generic-button.component";
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { MainModel } from '../../../../global/model/MainModel';
import { AddExpenseService } from '../../../services/add-expense.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'expense-add-app-stepper',
  templateUrl: './expense-add-stepper.component.html',
  styleUrls: ['./expense-add-stepper.component.scss'],
  standalone: true,
  imports: [StepsModule, ExpenseAddDetailsComponent, ExpenseAddLineItemsComponent, ExpenseAddApprovalsComponent,
    ExpenseAddComplianceComponent, ExpenseAddItemizationComponent, CommonModule, StepperModule, ButtonModule, GenericButtonComponent, ToastModule, DialogModule],
  providers: [MessageService, ConfirmationService, AddExpenseService]
})
export class ExpenseAddStepperComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() existingexpenseId: number = 0;
  campaignId!: number;
  expenseId: number = 0;
  expenseDetails: any;
  activeIndex = 0;
  @ViewChild('addExpenseStepper') addExpenseStepper!: Stepper;
  @ViewChild('detailsComp') detailsComp!: ExpenseAddDetailsComponent;
  @ViewChild('lineItemsComp') lineItemsComp!: ExpenseAddLineItemsComponent;
  @ViewChild('approvalsComp') approvalsComp!: ExpenseAddApprovalsComponent;
  @ViewChild('complianceComp') complianceComp!: ExpenseAddComplianceComponent;
  @ViewChild('itemizationComp') itemizationComp!: ExpenseAddItemizationComponent;
  @Output() closeDialog = new EventEmitter<void>();

  showStepper = true;
  dialogVisible = false;
  dialogMessage!: string;
  private dialogAcceptCallback?: () => void;
  private dialogRejectCallback?: () => void;

  steps = [
    { label: 'Expense Details' },
    { label: 'Line Items & Attachments' },
    { label: 'Approvals' },
    { label: 'Compliance' },
    { label: 'Itemizations' }
  ];

  constructor(private messageService: MessageService, private confirmationService: ConfirmationService, private mainModel: MainModel, private addExpenseService: AddExpenseService) { }
  ngOnInit(): void {
    if (this.existingexpenseId && this.existingexpenseId > 0) {
      this.expenseId = this.existingexpenseId;
    }
    const c: any = this.mainModel.selectedCampaign();
    this.campaignId = parseInt(c?.campaignId);
  }
  ngOnChanges(changes: SimpleChanges): void {

  }

  ngAfterViewInit() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 0;
    }
  }

  onExpenseSelected(id: number) {
    this.expenseId = id;
  }

  onExpenseDetailsSelected(details: any) {
    this.expenseDetails = details;
  }

  onNextStep() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 1;
      this.activeIndex = 1;
    }
  }
  onNextStep2() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 2;
      this.activeIndex = 2;
    }
  }
  onNextStep3() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 3;
      this.activeIndex = 3;
    }
  }
  onNextStep4() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 4;
      this.activeIndex = 4;
    }
  }
  onNextStep5() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 5;
      this.activeIndex = 5;
    }
  }

  async onPrevStep0() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 0;
      this.activeIndex = 0;
    }
  }
  onPrevStep1() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 1;
      this.activeIndex = 1;
    }
  }
  onPrevStep2() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 2;
      this.activeIndex = 2;
    }
  }
  onPrevStep3() {
    if (this.addExpenseStepper) {
      this.addExpenseStepper.activeStep = 3;
      this.activeIndex = 3;
    }
  }


  resetStepper() {
    this.addExpenseStepper.activeStep = 0;
  }

  ngOnDestroy() {
    this.addExpenseStepper.activeStep = 0;
    this.activeIndex = 0;
    this.showStepper = false;
    console.debug('Component destroyed, state reset');
  }

  showError(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }

  confirmAction(
    message: string,
    acceptCallback: () => void,
    rejectCallback?: () => void
  ) {
    this.dialogMessage = message;
    this.dialogAcceptCallback = acceptCallback;
    this.dialogRejectCallback = rejectCallback;
    this.dialogVisible = true;
  }

  onDialogAccept() {
    this.dialogVisible = false;
    this.dialogAcceptCallback?.();
  }

  onDialogReject() {
    this.dialogVisible = false;
    this.dialogRejectCallback?.();
  }

  async saveExpense() {
    let success = false;
    let initialPages = false;
    try {
      switch (this.activeIndex) {
        case 0:
          const detailSaved = await this.detailsComp.onSaveExpense();
          let lineItemSaved = false;
          if (detailSaved) {
            const data = await firstValueFrom(this.addExpenseService.getExpenselineitems(this.expenseId, false));
            lineItemSaved = data && data.length > 0;
          }
          success = detailSaved && lineItemSaved;
          if (!success) {
            initialPages = true;
          }
          break;
        case 1:
          success = await this.lineItemsComp.onSaveExpense();
          break;
        case 2:
          success = await this.approvalsComp.onSaveExpense();
          break;
        case 3:
          success = await this.complianceComp.onSaveExpense();
          break;
        case 4:
          success = await this.itemizationComp.onSaveExpense();
          break;
      }
      if (success) {
        this.closeDialog.emit();
      }
      else if(initialPages){
         this.messageService.add({ severity: 'error', summary: 'Error', detail: initialPages ? 'Step 1 & Step 2 are required, please add atleast one line item!' : 'Failed to complete step.' });
      }
    } catch (err) {
      // Optional: handle errors centrally
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to complete step.' });
    }
  }
  async closeExpense() {
    let success = false;
    try {
      switch (this.activeIndex) {
        case 0:
          success = true;
          break;
        case 1:
          if (this.existingexpenseId)
            success = await this.lineItemsComp.onSaveExpense();
          else
            await this.addExpenseService.deleteExpenseRequest(this.expenseId).subscribe({
              next: (data) => {
                success = data
                if (success) {
                  this.closeDialog.emit();
                }
              },
              error: () => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete new expense.' });
              }
            });
          break;
        case 2:
          success = true;
          break;
        case 3:
          success = true;
          break;
        case 4:
          success = true;
          break;
      }
      if (success) {
        this.closeDialog.emit();
      }
    } catch (err) {
      // Optional: handle errors centrally
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to complete step.' });
    }
  }
}